import { MapStyle } from '../CustomMap';

export const DEFAULT_ZOOM_TO_LOCATION_LEVEL = 6;

export const MAP_STYLES: Record<MapStyle, string> = {
  default: 'mapbox://styles/seedtrace/clia0bhp5004l01pghikh13gg',
  satellite: 'mapbox://styles/seedtrace/clon0fll500bi01nzfrjgfbs9'
};
